import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import CommunityGuidelinesView from 'src/views/CommunityGuidelines';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true
  }
}));
export default CommunityGuidelinesView;